export const site = {
  name: 'Hydrosprings',
  wordmark: 'HYDROSPRINGS',
  tagline: 'The world\u2019s first 100% chemical-free pool system.',
  partner: 'Fusion 44X',
  attribution:
    'Hydrosprings is an authorized dealer and installer of the Fusion 44X system. Fusion 44X, Hydro-pH-Infusion and related marks are the property of their respective owners. Hydrosprings makes no claim of ownership over the underlying technology.',
  // Used only to build sms: links — never displayed in the UI.
  smsNumber: '+12398723669',
  region: 'Serving all 50 states \u00b7 Concierge program in Florida',
}

export const navLinks = [
  { label: 'Shop systems', to: '/shop' },
  { label: 'The technology', to: '/technology' },
  { label: 'Contact', to: '/contact' },
]

export const guarantees = [
  'Chemical-free solution',
  'Eco friendly',
  'Safe. Certified. EPA standard.',
  'Lifetime warranty',
  '30-day money back guarantee',
]
